import React from 'react';
import "./Archive.css";
import ArchItem from "./ArchItem";

function Archive() {
    return (
        <div className="Archive">
            <header>
                <h1>Archive</h1>
                <p>A big list of thing's I've worked on</p>
            </header>

            <div className="table-top">
                <h5 className="year">Year</h5>
                <h5 className="title">Title</h5>
                <h5 className="techStack">Built with</h5>
                <h5 className="link">Link</h5>
            </div>

            <ArchItem year="2020" title="Netflix Clone Application" techStack="React JS · Firebase · Material UI"/>
            <ArchItem year="2020" title="Instagram Clone Application" techStack="React JS · Firebase · Material UI · TMDB API"/>
            <ArchItem year="2020" title="Spotify Clone Application" techStack="React JS · Firebase · Material UI · Spotify API"/>
            <ArchItem year="2020" title="YouTube Clone Application" techStack="React JS · Firebase · Material UI"/>
            <ArchItem year="2020" title="Amazon Full-Stack Clone Application" techStack="React JS · Firebase · Material UI · Context API"/>
            <ArchItem year="2020" title="Github Profile Finder Application" techStack="React JS · Github Jobs API · Material UI"/>
            <ArchItem year="2020" title="Google Maps Clone Application" techStack="JavaScript · Mapbox API · Geo-location API"/>
            <ArchItem year="2020" title="Spectrum Technical Club Website" techStack="HTML · CSS · JavaScript"/>
            <ArchItem year="2020" title="Binary Bytes Website" techStack="HTML · CSS · JavaScript · Django"/>
            <ArchItem year="2020" title="The Movie DB Application" techStack="React JS · TMDB API · Material UI"/>
            <ArchItem year="2020" title="TRVL Website - Travel Bookings Website" techStack="React JS · BootStrap · React-Router"/>
            <ArchItem year="2020" title="The Weather Application" techStack="HTML · CSS · Django · Weather API"/>
        </div>
            
    )
}

export default Archive
